import { render, staticRenderFns } from "./gateway-accounts.vue?vue&type=template&id=23a723ca&"
import script from "./gateway-accounts.vue?vue&type=script&lang=js&"
export * from "./gateway-accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports